import componentModule from './component';
import componentTypeModule from './componentType';
import measureTypeModule from './measureType';
import recipeModule from './recipe';
import productionOrderModule from './productionOrder';
import boxModule from './box';
import warehouseModule from './warehouse';
import supplierModule from './supplier';
import customerModule from './customer';
import purchaseOrderModule from './purchaseOrder';
import stationTypeModule from './stationType';
import routeModule from './route';
import stationModule from './station';
import wipModule from './wip';
import stepExecutionModule from './stepExecution';
import inventoryModule from './inventory';
import identityModule from './identity';
import userModule from './user';
import roleModule from './role';
import incidentModule from './incident';
import defectModule from './defect';
import defectReasonModule from './defectReason';
import pulseModule from './pulse';
import notificationModule from './notification';
import billingModule from './billing';
import organizationModule from './organization';
import analyticsModule from './analytics';
import instance from './instance';
import identityInstance from './identityInstance';
import pulseInstance from './pulseInstance';

export default {
  component: componentModule(instance),
  componentType: componentTypeModule(instance),
  measureType: measureTypeModule(instance),
  recipe: recipeModule(instance),
  productionOrder: productionOrderModule(instance),
  box: boxModule(instance),
  warehouse: warehouseModule(instance),
  supplier: supplierModule(instance),
  customer: customerModule(instance),
  purchaseOrder: purchaseOrderModule(instance),
  stationType: stationTypeModule(instance),
  route: routeModule(instance),
  station: stationModule(instance),
  wip: wipModule(instance),
  stepExecution: stepExecutionModule(instance),
  inventory: inventoryModule(instance),
  identity: identityModule(identityInstance),
  user: userModule(instance),
  role: roleModule(instance),
  incident: incidentModule(instance),
  defect: defectModule(instance),
  defectReason: defectReasonModule(instance),
  pulse: pulseModule(pulseInstance),
  notification: notificationModule(pulseInstance),
  billing: billingModule(instance),
  organization: organizationModule(instance),
  analytics: analyticsModule(instance)
};
